var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFastestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.39196 6.59519L3.94363 3.14269C5.5928 0.911019 6.4178 -0.204815 7.18696 0.0310188C7.95613 0.266852 7.95613 1.63519 7.95613 4.37269V4.63102C7.95613 5.61852 7.95613 6.11185 8.27196 6.42102L8.28863 6.43769C8.61113 6.74019 9.12446 6.74019 10.152 6.74019C12.002 6.74019 12.9261 6.74019 13.2386 7.30102L13.2536 7.32935C13.5486 7.89852 13.0128 8.62352 11.942 10.071L9.3903 13.5244C7.7403 15.756 6.91613 16.8719 6.14696 16.636C5.3778 16.4002 5.3778 15.0319 5.3778 12.2944V12.036C5.3778 11.0485 5.3778 10.5552 5.06196 10.246L5.0453 10.2294C4.7228 9.92685 4.20946 9.92685 3.18196 9.92685C1.33196 9.92685 0.407797 9.92685 0.0961303 9.36602L0.0802973 9.33769C-0.214703 8.76852 0.321131 8.04435 1.39196 6.59602",
    fill: "#EC9832"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastestIcon);
export default __webpack_public_path__ + "static/media/fastest-icon.42b679c8489c81e427f42525f5d59d0b.svg";
export { ForwardRef as ReactComponent };